module.exports = __webpack_public_path__ + "img/errorImg.26da89a1.png";